import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {Message} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    record: Omit<Message, 'id'>,
    handleSubmit: (values: Message) => void
}) => {
    const navigate = useNavigate()

    const onSubmit = (values: Message) => {
        handleSubmit(values);
        navigate('/messages');
    };

    const onCancel = () => {
        navigate('/messages');
    };


    let initialValues = {} as Message;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
